export default "__VITE_ASSET__CE$ZoGCf__"